import React, { useEffect, useState } from "react";

import PageContainer from "../components/shared/PageContainer";
import TemplatesTable from "../components/template/TemplatesTable";
import * as Objects from "../services/api";

export const Templates: React.FC = () => {
  const [templates, setTemplates] = useState<Objects.Template[]>([]);
  const [templateSetNameMap, setTemplateSetNameMap] = useState<Map<string, string>>(new Map());

  useEffect(() => {
    Objects.Templates.list().then(setTemplates);
    Objects.TemplateSets.list().then((result) =>
      setTemplateSetNameMap(
        new Map<string, string>(result.map((i) => [i.id, i.disabled ? `${i.name} (deleted)` : i.name])),
      ),
    );
  }, []);

  return (
    <PageContainer>
      <TemplatesTable templates={templates} templateSetNameMap={templateSetNameMap} />
    </PageContainer>
  );
};

export default Templates;
